import _export from "../internals/export";
import _globalThis2 from "../internals/global-this";
import _task from "../internals/task";
import _schedulersFix from "../internals/schedulers-fix";
var $ = _export;
var _globalThis = _globalThis2;
var setTask = _task.set;
var schedulersFix = _schedulersFix;

// https://github.com/oven-sh/bun/issues/1633
var setImmediate = _globalThis.setImmediate ? schedulersFix(setTask, false) : setTask;

// `setImmediate` method
// http://w3c.github.io/setImmediate/#si-setImmediate
$({
  global: true,
  bind: true,
  enumerable: true,
  forced: _globalThis.setImmediate !== setImmediate
}, {
  setImmediate: setImmediate
});
export default {};